<template>
  <div>
    <div
      v-if="porcentagem !== null"
      style="width: 250px"
      class="md-layout md-alignment-top-center"
    >
      <span>{{ componente.value.label }}</span>
      <vue-gauge
        :key="idRender"
        :refid="refid"
        :options="{
          needleColor: '#000000',
          arcColors: ['#efd613', '#3dcc5b', '#ff5454'],
          arcDelimiters: [100 / 3, (100 * 2) / 3],
          arcOverEffect: false,
          arcLabels: [
            `${(intervalo / 3 + componente.value.min).toFixed(2)}`,
            `${((intervalo * 2) / 3 + componente.value.min).toFixed(2)}`,
          ],
          arcLabelFontSize: 11,
          rangeLabel: [`${componente.value.min}`, `${componente.value.max}`],
          centralLabel: `${value ? value.valor.toFixed(2) : '-'}`,
          needleValue: porcentagem,
          needleStartValue: oldPorcentagem,
        }"
      />
      <p style="margin-top: -4vh">
        <span>
          {{ formatedDate }}
          <md-tooltip md-direction="bottom">{{ fullFormatedDate }}</md-tooltip>
        </span>
      </p>
    </div>
    <div v-else style="text-align: left">
      <md-progress-spinner
        :md-diameter="50"
        :md-stroke="5"
        md-mode="indeterminate"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VueGauge from 'vue-gauge'

import {
  registerChannelListener,
  removeChannelListener,
} from '@/utils/web-socket'

import http from '../../../utils/http'

export default {
  name: 'ViewShowDial',
  components: { VueGauge },
  props: {
    componente: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      idRender: (Math.random() + 1).toString(36).substring(7),
      refid: null,
      intervalo: null,
      value: null,
      porcentagem: 0,
      oldPorcentagem: 0,
      refToListener: null,
      refToListenerVirtual: null,
    }
  },
  computed: {
    formatedDate() {
      if (this.value === null) return null

      const date = new Date(this.value.horarioColeta)
      return moment(date).format('HH:mm')
    },
    fullFormatedDate() {
      if (this.value === null) return null

      const date = new Date(this.value.horarioColeta)
      return date.toLocaleString()
    },
  },
  async beforeMount() {
    this.refid = 'vue-gauge' + (Math.random() + 1).toString(36).substring(7)

    if (this.componente.value.sensorVirtualId !== null) {
      await this.beginListenSensoresVirtuais()

      this.value = {
        horarioColeta: new Date().toISOString(),
        valor: await this.getSensorVirtualValue(
          this.componente.value.sensorVirtualId
        ),
      }
    }

    if (this.componente.value.sensorId !== null) {
      await this.beginListenSensores()

      this.value = await http.get(
        `sensor/${this.componente.value.sensorId}/ultima-coleta`
      )
    }

    await this.updateValue()
  },
  beforeDestroy() {
    if (this.refToListener !== null)
      removeChannelListener(
        'view_sensor_id:' + this.componente.value.sensorId,
        'sensor:update_value',
        this.refToListener
      )

    if (this.refToListenerVirtual !== null)
      removeChannelListener(
        'sensor_virtual_id:' + this.componente.value.sensorVirtualId,
        'update_value',
        this.refToListenerVirtual
      )
  },
  methods: {
    async getSensorVirtualValue(id) {
      return await http
        .get(`sensor/virtual/${id}/evaluate`)
        .then((e) => e.result)
    },
    async beginListenSensoresVirtuais() {
      this.refToListenerVirtual = await registerChannelListener(
        'sensor_virtual_id:' + this.componente.value.sensorVirtualId,
        'update_value',
        (payload) => {
          this.value = {
            horarioColeta: payload.horario,
            valor: payload.result,
          }

          this.$nextTick(() => {
            this.updateValue()
          })
        }
      )
    },
    async beginListenSensores() {
      this.refToListener = await registerChannelListener(
        'view_sensor_id:' + this.componente.value.sensorId,
        'sensor:update_value',
        (payload) => {
          this.value = payload

          this.$nextTick(() => {
            this.updateValue()
          })
        }
      )
    },
    async updateValue() {
      this.intervalo = this.componente.value.max - this.componente.value.min

      this.oldPorcentagem = this.porcentagem
      this.porcentagem = this.getPorcentagem()

      this.idRender = (Math.random() + 1).toString(36).substring(7)
    },
    getPorcentagem() {
      if (this.value.valor <= this.componente.value.min) {
        return 0
      } else if (this.value.valor >= this.componente.value.max) {
        return 100
      } else {
        return (
          ((this.value.valor - this.componente.value.min) * 100) /
          this.intervalo
        )
      }
    },
  },
}
</script>

<style scoped></style>
